"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenueTable = void 0;
const mithril_1 = __importDefault(require("mithril"));
const venue_1 = require("../../../model/venue");
const helpers_1 = require("../../../utils/helpers");
const table_renderers_1 = require("../../../utils/table_renderers");
const table_1 = require("../../../widgets/table");
const venue_form_1 = require("./venue_form");
exports.VenueTable = (0, table_1.createTable)({
    id: "venueTable",
    filters: [],
    provider: venue_1.VenueProvider,
    title: "Clients",
    topMenuRight: () => {
        return [
            (0, mithril_1.default)("a", { class: "button is-success with-margin", onclick: () => {
                    venue_form_1.VenueForm.show();
                } }, (0, helpers_1.iconSpan)("fa-user-plus", "is-small"), (0, mithril_1.default)("span", "Nouveau Centre"))
        ];
    },
    fields: [
        {
            name: "id",
            sortable: true,
            label: "n°"
        },
        {
            name: "name",
            sortable: true,
            label: "Nom"
        },
        {
            name: "address",
            sortable: true,
            label: "Adresse"
        },
        {
            name: "active",
            sortable: true,
            label: "Actif",
            renderer: table_renderers_1.TableRenderers.bool
        },
        {
            name: "created_at",
            sortable: true,
            label: "Créé le",
            renderer: table_renderers_1.TableRenderers.date
        }
    ],
    actions: (_obj) => {
        return (0, mithril_1.default)("div", { class: "" });
    }
});
